module.exports = __webpack_public_path__ + "static/img/style1-h5.e0859d31.png";